import React from 'react'
import { useSelector } from 'react-redux'
import { Redirect, Route } from 'react-router'
import { IState } from 'src/models/state'

interface IProps {
	// include component properties here.
	path: string
	component: any
	exact?: boolean
}

export const PrivateRoute = (props: IProps) => {

	const isLogged = useSelector<IState, boolean>((state) => state.user.isLogged)

	return (
		isLogged ?
			<Route path={props.path} component={props.component} exact={props.exact} />
			:
			<Redirect to='/login' />
	)
}



// WEBPACK FOOTER //
// ./src/components/privateRoute.tsx